import React, { useEffect, useState } from "react";
import { emailValidation, passwordValidation, requiredFieldValidation } from '../../utils/validation';
import { Container } from '@material-ui/core';
import logo from '../../images/techStart.png';
import { Checkbox, InputField, PrimaryButton } from '../../elements'

const LoginPage = props => {
  const { login, currentUser, isLoading, history, error } = props;
  const [fieldState, setFieldState] = useState({
    email: localStorage.getItem('email'),
    password: "",
  });
  const [remembered, setRemembered] = useState(Boolean(localStorage.getItem('email')))

  const [errorState, setErrorState] = useState({
    email: null,
    password: null,
  });

  useEffect(() => {
    currentUser && history.push('/');
    // eslint-disable-next-line
  }, [currentUser])

  const onChange = event => {
    setFieldState({ ...fieldState, [event.target.name]: event.target.value });
  };

  const submitHandle = () => {
    if (remembered) {
      localStorage.setItem('email', fieldState.email);
    } else {
      localStorage.removeItem('email')
    }
    let errors = {
      email: requiredFieldValidation(fieldState.email, 'Email') || emailValidation(fieldState.email),
      password: requiredFieldValidation(fieldState.password, 'Password') || passwordValidation(fieldState.password),
    }
    setErrorState(errors);
    if (!Object.values(errors).some(el => !!el)) login(fieldState);
  }

  return (
    <div className="auth-page">
      <img src={logo} alt="logo" className="auth-logo" />
      <Container className="auth-card" maxWidth="sm">
        <h3>Sign In</h3>
        <InputField
          name='email'
          id='email'
          value={fieldState.email}
          label='Email'
          error={errorState.email}
          onChange={onChange}
          onEnterPress={submitHandle}
          disabled={isLoading}
        />
        <InputField
          name='password'
          id='password'
          label='Password'
          type='password'
          value={fieldState.password}
          error={errorState.password}
          onChange={onChange}
          onEnterPress={submitHandle}
          disabled={isLoading}
        />
        <div className='text-center' style={{ marginBottom: '20px' }}>
          <div style={{ height: '24px' }}>
            {Boolean(error) && <div className="error">{error}</div>}
          </div>
          <Checkbox
            label={<span style={{ color: remembered ? 'var(--regular-text)' : 'var(--placeholder-text)' }}>Remember me</span>}
            id='remember'
            checked={remembered}
            onChange={() => setRemembered(!remembered)}
            style={{ marginLeft: '5px', marginTop: '10px', marginBottom: '10px' }}
            labelPlacement='start' />
          <PrimaryButton isLoading={isLoading} fullWidth={true} id='submit' onClick={submitHandle}>
            Login
          </PrimaryButton>
        </div>
        <p className="text-center">
          <a href="/remind-password">Remind Password</a>
        </p>
      </Container>
      <p className="text-center pb-4">
        Don't have an account? <a href="/registration">Create One</a>
      </p>
    </div>
  );
};

export default LoginPage;
